<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc("edit") }} {{ $t("seattype") }}</div>
      <router-link class="btn-blue" to="seat-type"
        >{{ $t("seattype") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-md-6 col-xl-4 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">
                {{ $tc("cinema", 2) }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :disabled="this.isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema()"
                      v-on:keydown="onSearchCinema()"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                    >{{ Cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <!-- <Tooltip :title="$t('seatType_SelectCinemas')" /> -->
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0"
                >Please Select Cinema.</span
              >
            </p>
          </div>

          <div class="col-md-6 col-xl-4 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedScreen.length > 0 ? 'shift-up' : ''">{{
                $tc("screen", 1)
              }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedScreen"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(Screen, ScreenIndex) in Screens"
                    :key="ScreenIndex"
                    v-on:click="onSelectScreen($event, Screen)"
                    >{{ Screen.screen_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <!-- <Tooltip :title="$t('seatType_SelectScreen')" /> -->
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedScreen.length == 0"
                >Please Select Screen.</span
              >
            </p>
          </div>

          <div class="col-md-6 col-xl-4 mb-4">
            <div class="d-flex justify-content-center align-items-center">
              <div class="input-material">
                <input
                  v-model="seatTypes.sst_seat_type"
                  type="text"
                  name="seattype"
                  id="seattype"
                  v-validate="'required|alpha_spaces'"
                  placeholder="."
                />
                <label>{{ $tc("seat", 2) }} {{ $tc("type", 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t('seatType_SeatsTypes')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('seattype')">{{
                errors.first("seattype")
              }}</span>
            </p>
          </div>

          <div class="col-md-6 col-xl-4 mb-4">
            <div class="d-flex justify-content-center align-items-center">
              <div class="input-material">
                <input
                  v-model="seatTypes.sst_no_of_seats"
                  type="text"
                  step="any"
                  name="seatno"
                  id="seatno"
                  v-validate="'required|numeric'"
                  placeholder="."
                />
                <label>{{ $t("noofseats") }}</label>
              </div>
              <!-- <Tooltip :title="$t('seatTypeSeatno_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('seatno')">{{
                errors.first("seatno")
              }}</span>
            </p>
          </div>

          <div class="col-md-6 col-xl-4 mb-4">
            <div class="row">
              <div class="col-6">
                <div class="shift-name-label bg-white border">
                  {{ $tc("seat", 1) }} Color {{ $t("code") }}
                </div>
              </div>
              <label class="select-color">
                <input v-model="seatTypes.sst_seat_color_code" type="color" />
              </label>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-xl-4 mb-4 align-self-center">
            <div class="d-flex w-100 align-items-center">
              <span class="pr-3">Active</span>

              <b-form-checkbox
                v-model="seatTypes.sst_is_active"
                unchecked-value="N"
                value="Y"
                name="check-button"
                class="j-checkbox"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <!-- <div class="col-md-6 col-xl-4 mb-4">
            <div class="row">
              <div class="col-4">
                <b-form-checkbox
                  disabled
                  v-model="seatTypes.sst_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>-->

          <div class="col-12 text-center">
            <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
              Update
            </button>
            <router-link to="seat-type" class="btn-outline-grey"
              >Cancel</router-link
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import ScreenService from "@/services/ScreenService";
import SeatService from "@/services/SeatService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      submitted: false,
      isRoleID: true,
      cinema_id: null,
      // Saif
      Cinemas: [],
      Screens: [],
      selectedCinema: "",
      selectedScreen: "",
      selectedCinemaId: "",
      seatTypes: {
        cinema_id: null,
        screen_id: null,
        sst_id: null,
        sst_seat_type: "",
        sst_seat_color_code: "#FF0000",
        sst_no_of_seats: 0,
        sst_is_active: "Y",
        updated_at: new Date(),
        updated_by: 1,
      },
      // Saif
      selectedKey: "",
      notesRemarks: "",
      validate: false,
      selectedCinema: "",
      selectedHardwareType: "",
    };
  },
  computed: {
    validStatus() {
      return this.validate ? true : false;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    const { id } = this.$route.query;
    if (id) {
      this.getSeatTypesDetails(id);
      // this.getScreenList();
      this.getCinemaList(obj);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    // Saif
    getSeatTypesDetails: function (sst_id) {
      SeatService.GetSeatTypesById({ sst_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data :", data);
            this.seatTypes = {
              ...this.seatTypes,
              ...data.Records[0],
            };
            console.log("this.seatTypes :", this.seatTypes);

            this.selectedCinema = data.Records[0].cine_name;
            this.selectedScreen = data.Records[0].screen_name;
            this.selectedCinemaId = data.Records[0].cine_id;
            this.getScreenList();
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getSeatTypesDetails :", error);
        });
    },

    getCinemaList(cine_id) {
      CinemasService.GetActiveCinemas({
        activekey: "cine_is_active",
        conditionColName: "cine_id",
        conditionId: this.cinema_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getScreenList: function () {
      this.Screens = [];
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: this.selectedCinemaId,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Screens = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
      // ScreenService.GetActiveScreens({ activekey: "screen_is_active" })
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       this.Screens = data.Records;
      //       console.log("this.Screens :", this.Screens);
      //     } else {
      //       // Show Error Message:
      //       console.log("data.message :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     // Catch Error:
      //     console.log("Catch Error On getScreenList :", error);
      //   });
    },
    onResetForm: function () {
      this.selectedCinema = "";
      this.selectedScreen = "";
      this.seatTypes = {
        cinema_id: null,
        screen_id: null,
        sst_id: null,
        sst_seat_type: "",
        sst_seat_color_code: "",
        sst_no_of_seats: 0,
        sst_is_active: "Y",
        updated_at: new Date(),
        updated_by: 1,
      };
    },
    onFinalSubmit: function () {
      console.log("payload=.", this.seatTypes);
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        console.log("Valid :", valid);
        if (valid) {
          let payload = {
            ...this.seatTypes,
          };
          SeatService.UpdateSeatTypes(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                this.$router.push({
                  path: "/cinema-manager/seat-type",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.seatTypes.cinema_id = params.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },
    onSelectScreen: function (event, params) {
      this.selectedScreen = params.screen_name;
      this.seatTypes.screen_id = params.screen_id;
    },
    // Saif
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SeatTypeComponents/editSeatType.vue